/*
 * Babel removed the `forEach` function from some DOMCollections
 * in 3.18:
 * https://github.com/zloirock/core-js/issues/988
 * https://github.com/zloirock/core-js/pull/987
 * Because this function is used extensively throughout the code,
 * we're adding it again here.
 */
HTMLCollection.prototype.forEach = Array.prototype.forEach
